import ReactModal from 'react-modal';
import React from 'react';
import { createModal } from 'react-modal-promise';

class RefundPurchaseModal extends React.Component {
  state = {
    refundId: '',
    cancelPurchase: false,
  };

  handleRefundChange = (e) => {
    this.setState({ refundId: e.target.value });
  };

  handleCancelPurchaseChange = (e) => {
    this.setState({ cancelPurchase: e.target.checked });
  };

  render() {
    const { open, close } = this.props;
    const { refundId, cancelPurchase } = this.state;
    return (
      <ReactModal
        appElement={document.getElementById('root')}
        isOpen={open}
        contentLabel="Minimal Modal Example"
        portalClassName="AdjustmentCreditPortal"
        overlayClassName="AdjustmentCreditModal__Overlay"
        className="AdjustmentCreditModal__Content"
      >
        <div className="modal-header">
          <span className="close" onClick={() => close(false)}>
            &times;
          </span>
          <h2>Confirm Refund Purchase</h2>
        </div>
        <div className="modal-body">
          <p>Are you sure you want to refund purchase?</p>
          <div className="form-group">
            <label className="control-label">Refund Id</label>
            <input
              className="form-control"
              name="refundId"
              value={refundId}
              onChange={this.handleRefundChange}
            />
          </div>
          <div className="checkbox">
            <label>
              <input
                type="checkbox"
                checked={cancelPurchase}
                onChange={this.handleCancelPurchaseChange}
              />
              Cancel Purchase
            </label>
          </div>
        </div>
        <div className="modal-footer">
          <button
            className={'btn btn-primary'}
            onClick={() => close({ refundId, cancelPurchase })}
          >
            Confirm
          </button>
          <button className={'btn'} onClick={() => close(false)}>
            Cancel
          </button>
        </div>
      </ReactModal>
    );
  }
}

export default createModal(RefundPurchaseModal);
